var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 220,
    viewBox: "0 0 330 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 220H330V40.2202C330 31.3836 322.837 24.2202 314 24.2202H122.958C118.775 24.2202 114.758 22.5818 111.768 19.6561L96.345 4.56411C93.355 1.63837 89.3381 0 85.1548 0H0V220Z",
    fill: "#1F242E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 220,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderback);
export default __webpack_public_path__ + "static/media/folderback.b3db87fbd25f3e4e4506c5a27b7ebd76.svg";
export { ForwardRef as ReactComponent };